import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './plugins/element.js'
import router from './Router/router'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import store from './vuex/store.js'
// 引入JQ
import $ from 'jquery'
Vue.use(preview)

// router.beforeEach((to, from, next) => {
//         /* 路由发生变化修改页面title */
//         if (to.meta.title) {
//             document.title = to.meta.title
//         }
//         next()
//     })
// 路由拦截守卫，未登录状态下拒绝用户进入某一些页面
router.beforeEach((to, from, next) => {

    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }

    // // 路由拦截判断当前用户是否有分销参数，如果有则维持路由跳转时分销参数的携带
    if (to.query.distrid) {
        next();
        return;
    } else {
        next();
    }
    if (from.query.distrid) {
        let toQuery = JSON.parse(JSON.stringify(to.query));
        toQuery.distrid = from.query.distrid;
        next({
            path: to.path,
            query: toQuery
        })
    } else {
        next()
    }


    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
        let url = window.location.origin
        url = url + "/getInfo"
            //步骤一:创建异步对象
        var ajax = new XMLHttpRequest();
        //步骤二:设置请求的url参数,参数一是请求的类型,参数二是请求的url,可以带参数,动态的传递参数starName到服务端
        ajax.open('get', url);
        //步骤三:发送请求
        ajax.send();
        //步骤四:注册事件 onreadystatechange 状态改变就会调用
        ajax.onreadystatechange = function() {
            if (ajax.readyState == 4 && ajax.status == 200) {
                //步骤五 如果能够进到这个判断 说明 数据 完美的回来了,并且请求的页面是存在的
                let json = JSON.parse(ajax.responseText);
                if (json.data.token != null) {
                    localStorage.setItem("token", json.data.token);
                    localStorage.setItem("agency_id", json.data.agency_id);
                    next();
                } else {
                    // 如果url中没有跳转详情页的camp参数则跳转登录页
                    // if (window.location.href.search(/camp/) == -1) {
                    //     let nowUrl = window.location.href
                    //     nowUrl = nowUrl.replace(/#/g, 'vue')
                    //     let url = window.location.origin
                    //     window.location.href = url + "/login?turn_jump_url=" + nowUrl
                    // }
                }
            }
        }
        next();
    } else {
        next();
    }
})

// // 路由拦截判断当前用户是否有分销参数，如果有则维持路由跳转时分销参数的携带
// router.beforeEach((to, from, next) => {
//     console.log("123123123123")
//     console.log(to)
//     console.log(from)
//     if (to.query.distrid) {
//         console.log("有分销")
//         next();
//         return;
//     }
//     if (from.query.) {
//         let toQuery = JSON.parse(JSON.stringify(to.query));
//         console.log("有分销")
//         toQuery.distrid = from.query.distrid;
//         next({
//             path: to.path,
//             query: toQuery
//         })
//     } else {
//         next()
//     }
// });


// 动态修改page title 
Vue.directive('title', { //单个修改标题

    inserted: function(el) {

        document.title = el.dataset.title

    }

})

Vue.config.productionTip = false
    // 将JQ注入原型
Vue.prototype.$ = $;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')